module.exports = __webpack_public_path__ + "img/kz.7020ac62.svg";